import React from "react";
import { Toast } from "antd-mobile";
import Http from "../../utils/http";
import * as Api from "../../utils/api";
import CommonNav from "../../components/goBack";
import md5 from "../../utils/Md5";
import Utils from "../../utils/utils";
const HttpInstance = new Http();
const utils = new Utils();
export default class VerificationComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scaleH: 0,
      phone: "",
      phoneNumber: "",
      verCode: "",
      time: 60,
      sendAgainFlag: true,
      openID: "",
    };
  }
  render() {
    const _this = this;
    return (
      <div className="bindContainer" style={{ minHeight: _this.state.scaleH }}>
        <CommonNav history={_this.props.history}></CommonNav>
        <h1 className="pageTitle">请输入验证码</h1>
        <p className="page-tips">验证码已发送至：{_this.state.phone}</p>
        <div className="vercode-iptcontianer">
          <div className="vercode-item">
            {_this.state.phoneNumber.length > 0
              ? _this.state.phoneNumber.substring(0, 1)
              : ""}
          </div>
          <div className="vercode-item">
            {_this.state.phoneNumber.length > 1
              ? _this.state.phoneNumber.substring(1, 2)
              : ""}
          </div>
          <div className="vercode-item">
            {_this.state.phoneNumber.length > 2
              ? _this.state.phoneNumber.substring(2, 3)
              : ""}
          </div>
          <div className="vercode-item">
            {_this.state.phoneNumber.length > 3
              ? _this.state.phoneNumber.substring(3, 4)
              : ""}
          </div>
        </div>
        <div className="ver-tipsContainer">
          {_this.state.time} 秒后可重新发送验证码
          <span onClick={_this.sendSMSCodeAgain.bind(_this)}>/重新发送</span>
        </div>
        <div className="van-number-keyboard van-number-keyboard--custom van-number-keyboard--safe-area-inset-bottom">
          <div className="van-number-keyboard__body">
            <i
              role="button"
              className="van-hairline van-key"
              onClick={_this.inputNumberKeyboard.bind(_this, 1)}
            >
              1
            </i>
            <i
              role="button"
              className="van-hairline van-key"
              onClick={_this.inputNumberKeyboard.bind(_this, 2)}
            >
              2
            </i>
            <i
              role="button"
              className="van-hairline van-key"
              onClick={_this.inputNumberKeyboard.bind(_this, 3)}
            >
              3
            </i>
            <i
              role="button"
              className="van-hairline van-key"
              onClick={_this.inputNumberKeyboard.bind(_this, 4)}
            >
              4
            </i>
            <i
              role="button"
              className="van-hairline van-key"
              onClick={_this.inputNumberKeyboard.bind(_this, 5)}
            >
              5
            </i>
            <i
              role="button"
              className="van-hairline van-key"
              onClick={_this.inputNumberKeyboard.bind(_this, 6)}
            >
              6
            </i>
            <i
              role="button"
              className="van-hairline van-key"
              onClick={_this.inputNumberKeyboard.bind(_this, 7)}
            >
              7
            </i>
            <i
              role="button"
              className="van-hairline van-key"
              onClick={_this.inputNumberKeyboard.bind(_this, 8)}
            >
              8
            </i>
            <i
              role="button"
              className="van-hairline van-key"
              onClick={_this.inputNumberKeyboard.bind(_this, 9)}
            >
              9
            </i>
            <i
              role="button"
              className="van-hairline van-key van-key--middle"
              onClick={_this.inputNumberKeyboard.bind(_this, 0)}
            >
              0
            </i>
          </div>
          <div className="van-number-keyboard__sidebar">
            <i
              role="button"
              className="van-hairline van-key van-key--delete van-key--big van-key--gray van-key--delete"
              onClick={_this.showNumberRemove.bind(_this)}
            >
              删除
            </i>
          </div>
        </div>
      </div>
    );
  }
  componentWillMount() {
    const _this = this;
    document.title = "绑定手机号码";
    window.scrollTo(0, 0);
    let phone = HttpInstance.getSearchByName(
      this.props.location.search,
      "phone"
    );
    let userInfo = JSON.parse(localStorage.getItem("loginData"));
    _this.setState(
      {
        scaleH: window.innerHeight + "px",
        phone: phone,
        openID: userInfo.openID,
      },
      () => {
        //发送验证码
        _this.sendSMSCode();
      }
    );
    let isApp = HttpInstance.getSearchByName(
      this.props.location.search,
      "isApp"
    );
    if (!isApp) {
      utils.wxShareConfig(_this, isApp);
    }
  }
  /**
   * 重新发送验证码
   *  */
  sendSMSCodeAgain() {
    const _this = this;
    if (_this.state.sendAgainFlag) {
      _this.sendSMSCode();
    }
  }
  sendSMSCode() {
    const _this = this;
    let param = {};
    let skeyString = "PhoneNo=" + _this.state.phone + "&dashalongV5";
    param.PhoneNo = _this.state.phone;
    param.openID = _this.state.openID;
    param.skey = md5.hexMD5(skeyString);
    let response = HttpInstance.post(Api.SEND_SMSCODE_API, param);
    response.then((data) => {
      let responseData = data.data;

      if (responseData.result) {
        let verCode = responseData.data.data;
        Toast.info("发送成功", 1);
        _this.setState(
          {
            verCode: verCode.VerCode,
            sendAgainFlag: false,
          },
          () => {
            _this.startTimer(_this);
          }
        );
      } else {
        if (responseData.status == "1002") {
          // 注销登录
          Toast.info(responseData.msg, 1);
          _this.props.history.goBack();
        } else {
          Toast.info(responseData.msg, 1);
        }
      }
    });
  }
  startTimer(obj) {
    const _this = obj;
    let Timer = setInterval(function () {
      if (_this.state.time < 1) {
        clearInterval(Timer);
        _this.setState({
          time: 60,
          sendAgainFlag: true,
        });
      } else {
        _this.setState({
          time: _this.state.time - 1,
        });
      }
    }, 1000);
  }
  inputNumberKeyboard(number) {
    const _this = this;
    if (_this.state.phoneNumber.length >= 4) {
    } else {
      _this.setState(
        {
          phoneNumber: _this.state.phoneNumber + number,
        },
        () => {
          /**
           * 绑定手机号
           * */
          if (_this.state.phoneNumber.length >= 4) {
            Toast.loading("绑定中...", 30, () => {});
            let params = {};
            params.openId = _this.state.openID;
            params.password = _this.state.phoneNumber;
            params.phoneNo = _this.state.phone;
            let response = HttpInstance.postJSON(Api.BIND_PHONE_API, params);
            response.then((data) => {
              let responseData = data.data;
              if (responseData.result) {
                Toast.info("绑定成功", 1);
                _this.props.history.go(-2);
              } else {
                Toast.info(responseData.msg, 1);
              }
            });
          }
        }
      );
    }
  }
  showNumberRemove() {
    const _this = this;
    if (_this.state.phoneNumber.length > 0) {
      let strLen = _this.state.phoneNumber.length;
      _this.setState({
        phoneNumber: _this.state.phoneNumber.substring(0, strLen - 1),
      });
    }
  }
}
